module.exports = __webpack_public_path__ + "static/korea-flag-31158b4f3be04d4b39b554c2ff1633c4.png";